module.exports = __webpack_public_path__ + "static/media/shinyCrystal.2eefaeef.jpg";